import React from 'react';
import { Modal } from 'antd';
import {
  Channel,
  Template,
  renderWithSample,
} from 'services/NotificationTemplatesService';
import useStyles from './styles';
import TemplatePreview from './TemplatePreview';

interface PreviewModalProps {
  classes: ReturnType<typeof useStyles>;
  open: boolean;
  onClose: () => void;
  channel: Channel;
  stateName: string;
  template?: Template;
  brandColor: string;
}

const PreviewModal = ({
  classes,
  open,
  onClose,
  channel,
  stateName,
  template,
  brandColor,
}: PreviewModalProps) => {
  const textBlock = template?.blocks.find((b) => b.type === 'text');
  const buttonBlock = template?.blocks.find((b) => b.type === 'button');
  const body = renderWithSample(textBlock?.content ?? '');

  return (
    <Modal
      title="Vista previa"
      open={open}
      onCancel={onClose}
      footer={null}
      width={channel === 'whatsapp' ? 380 : 420}
    >
      <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 12 }}>
        {stateName} · vista con datos de ejemplo
      </div>
      {channel === 'whatsapp' ? (
        <div className={classes.wmini} style={{ padding: 16, borderRadius: 8 }}>
          <div className={classes.bubble} style={{ fontSize: 12, padding: 12 }}>
            <div className={classes.bubbleTitle} style={{ fontSize: 13 }}>
              {stateName}
            </div>
            <div style={{ color: '#333' }}>{body}</div>
            {buttonBlock && (
              <div className={classes.bubbleBtn} style={{ fontSize: 12 }}>
                {buttonBlock.content}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={classes.email} style={{ maxWidth: 360, margin: '0 auto' }}>
          {template && (
            <TemplatePreview
              classes={classes}
              blocks={template.blocks}
              brandColor={brandColor}
              fillSample
            />
          )}
        </div>
      )}
    </Modal>
  );
};

export default PreviewModal;
